export default () => '/cyclops';
